<template>
  <router-view />
</template>

<script>
  import 'primevue/resources/themes/nova-light/theme.css';
  import 'primevue/resources/primevue.min.css';
  import 'primeicons/primeicons.css';

  export default {
    name: 'app',
    data: () => {
      return {
        navBarTop: true,
        appClass: 'home'
      }
    },
    components: {

    },
    methods: {
    }
  }
</script>

<style lang="scss">
</style>
